import { render, staticRenderFns } from "./ComputerOption.vue?vue&type=template&id=9d63bc26&scoped=true"
import script from "./ComputerOption.vue?vue&type=script&lang=js"
export * from "./ComputerOption.vue?vue&type=script&lang=js"
import style0 from "./ComputerOption.vue?vue&type=style&index=0&id=9d63bc26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d63bc26",
  null
  
)

export default component.exports